<script>
	import { ToggleBox, ToggleBoxGrid } from "../../../togglebox";
	import {  BetSettingsLocal } from "../../../../stores";
    import {
        createBetWs
    } from "../../../../scripts/stake-api";

    let n_rows = 9
    let n_cols = 4
   
    const diff_cols = {
        "easy": 4,
        "medium": 3,
        "hard": 2,
        "expert": 3,
        "master": 4
    }

    let props_toggleGrid
    $: props_toggleGrid = {
        cols: n_cols,
        rows: 1,
        hasControls: false,
        itemSize: "40px",
		borderColor: "#8e8e8e",
		backgroundColor: "#c6c6c6",
		backgroundColorChecked: "#c6c6c6",
		textColor: "transparent", //"#232323",
        textColorChecked: "transparent", //"#3b3b3b",

 
	};

    let _selectedNumbers = []
    export let selectedNumbers = null

    $: if(_selectedNumbers){ 
        console.log("[DEBUG] dragontower _selectedNumbers: ", _selectedNumbers)
        let s = []
        for (let row of _selectedNumbers) {
            
            if(![...row][0])
                break

            s.push( ([...row][0] - 1) )
           
        }

        selectedNumbers = s
        // selectedNumbers = [... _selectedNumbers].slice(0,10).map( v => parseInt(v)-1).sort((a,b) => a-b) 
    }

    
	$: if(selectedNumbers) { 
        BetSettingsLocal.update({eggs: [... selectedNumbers] })
     }
	$: if($BetSettingsLocal.difficulty) { 
        n_cols = diff_cols[$BetSettingsLocal.difficulty]
        /*BetSettingsLocal.update({eggs: [... selectedNumbers] })*/
     }


    export const placeBet =  async (...args) => {

        try {

            let r = await createBetWs(...args)
    
            return r
        } catch (e) {
            //any connection related error
            console.error("catch error fnc placeBet - e: ", e);
            return {error: e, data: null}
        }
        finally{

        }
    };
</script>

<div class="container">
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[8]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[7]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[6]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[5]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[4]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[3]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[2]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[1]} {... props_toggleGrid}></ToggleBoxGrid>	
    <ToggleBoxGrid maxSelectedItems=1 bind:selectedNumbers={_selectedNumbers[0]} {... props_toggleGrid}></ToggleBoxGrid>	
</div>

<style>
    .container {
        width: fit-content;;
        margin: auto;
        background-color: #fefefe;
    }

    .a {
        color: #9e9e9e
    }
</style>
